module.exports = __webpack_public_path__ + "static/media/boombox.ebb2a62a.svg";